export default __webpack_public_path__ + "static/media/Paints&painters.0bb944d0.png";